module.exports = __webpack_public_path__ + "static/media/logo-text.b68b7186.svg";